import { HENI_ORGANIZATION_REF } from '#lib/features/seo/constants/heni-organization.js';
import type { OfferAvailabilityValue } from '#lib/features/seo/constants/offer-availability.js';

interface ProductOfferInput {
	price: number | null | undefined;
	currency: string | null | undefined;
	availability: OfferAvailabilityValue;
	url: string;
}

const ISO_CURRENCY = /^[A-Z]{3}$/;

// Callers decide visibility and availability; this only refuses an Offer Google
// would reject.
export const getProductOffer = ({
	price,
	currency,
	availability,
	url,
}: ProductOfferInput) => {
	const priceCurrency = currency?.toUpperCase();

	if (!price || !priceCurrency || !ISO_CURRENCY.test(priceCurrency)) {
		return undefined;
	}

	return {
		'@type': 'Offer',
		price,
		priceCurrency,
		availability,
		url,
		seller: HENI_ORGANIZATION_REF,
	};
};
